import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function regExValidator(regex: RegExp, hint: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (regex.test(value)) {
      return null;
    }

    return { pattern: { required: hint, actual: value } };
  };
}
